import React, { useState, useEffect, useMemo } from "react"
import { Row, Col, Card, Table, Input } from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import Loader from "pages/Separate/Loader"
import { WorkingHoursColumns } from "utils/columns/Human Resource/WorkingHoursColumns"
import { fetchNodeData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"

function TableContainer({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [{ id: "date", desc: false }],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { globalFilter } = state

  return (
    <Row>
      <Col xl="12">
        <div className="card-body">
          <Row className="align-items-center justify-content-between ml-3 mb-3">
            <Col className="text-purple fs-5 fw-bold" md="auto">
              Current Month Working Hours
            </Col>
          </Row>

          <div className="table-responsive">
            <Table className="table table-bordered" {...getTableProps()}>
              <thead>
                {headerGroups.map((headerGroup, i) => (
                  <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column, index) => (
                      <th
                        key={index}
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                        className={`text-center`}
                      >
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>

              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row)
                  return (
                    <tr key={i} {...row.getRowProps()}>
                      {row.cells.map((cell, index) => (
                        <td
                          key={index}
                          {...cell.getCellProps()}
                          className={`text-center`}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </Col>
    </Row>
  )
}

const WorkingHours = () => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const token = secureLocalStorage.getItem("auth_token")
  const toggleLoading = loading => {
    setLoading(loading)
  }
  useEffect(() => {
    const fetchWorkingLeaves = async () => {
      const user_id = localStorage.getItem("auth_id")
      const res = await fetchNodeData(toggleLoading, `workingHours/${user_id}`, token)
      if (res?.success) {
        setData(
          res?.data?.map((obj, index) => ({
            id: index + 1,
            ...obj,
          }))
        )
      }
    }

    fetchWorkingLeaves()
  }, [])

  const column1 = useMemo(() => WorkingHoursColumns(), [])

  return (
    <div>
      {isLoading && <Loader />}
      <div className="position-relative">
        <Row>
          <Col lg="12">
            <Card>
              <div className="responsive-table">
                <TableContainer columns={column1} data={data} />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default WorkingHours
